import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, LayoutIcon } from '@streamr/tv-ui';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { IncomingRequestsButton } from '../broadcaster/IncomingRequestsButton';
import { showLayoutPopup } from '../popups/LayoutPopup';
import { BottomLeftSlot, HudSlots, TopLeftSlot, TopRightSlot, } from '../shared/HudSlots';
import { OverlayToggle } from '../shared/OverlayToggle';
import { PluginButtonTray as PrestyledPluginButtonTray } from '../shared/PluginButtonTray';
import { PluginComponentContainer } from '../shared/PluginComponentContainer';
import { PluginOverlayContainer } from '../shared/PluginOverlayContainer';
export function BroadcasterViewHud({ fullscreenButton, visible, onToggleMetrics, showMetrics, selectedLayout, onLayoutChange, currentBackground, onSelectBackground, onUploadBackgroundImage, showIncomingRequests = false, }) {
    const [showPluginOverlay, setShowPluginOverlay] = useState(true);
    const layoutButtonAnchorRef = useRef(null);
    return (_jsxs(_Fragment, { children: [_jsxs(Hud, { "$visible": visible, children: [_jsx(TopLeftSlot, { children: showIncomingRequests && (_jsx(IncomingRequestsButton, { popupPlacement: "below" })) }), _jsx(TopRightSlot, { children: _jsx(PluginButtonTray, { slotId: "buttonstray", hidden: !visible }) }), _jsxs(BottomLeftSlot, { children: [_jsx(OverlayToggle, { checked: showPluginOverlay, onChange: setShowPluginOverlay }), onToggleMetrics && (_jsx(MetricsToggle, { onClick: onToggleMetrics, title: showMetrics ? 'Hide Metrics' : 'Show Metrics', children: "\uD83D\uDCCA" })), onLayoutChange && (_jsx("div", { ref: layoutButtonAnchorRef, children: _jsx(LayoutButton, { title: "Layout", onClick: () => {
                                        showLayoutPopup({
                                            anchorRef: layoutButtonAnchorRef,
                                            selectedLayout: selectedLayout ?? 'auto',
                                            onLayoutSelect: (layout) => {
                                                onLayoutChange(layout);
                                            },
                                            currentBackground,
                                            onSelectBackground,
                                            onUploadBackgroundImage,
                                        });
                                    }, children: _jsx(LayoutIcon, {}) }) })), fullscreenButton] })] }), showPluginOverlay && _jsx(PluginOverlayContainer, { slotId: "overlay" }), _jsx(PluginComponentContainer, { slotId: "components" })] }));
}
const PluginButtonTray = styled(PrestyledPluginButtonTray) `
    position: static;
    top: auto;
    left: auto;
`;
const Hud = styled(HudSlots) `
    z-index: 10;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transition: opacity 0.3s ease-in-out;
    pointer-events: none; /* Let clicks pass through to canvas below */
    
    /* Allow pointer events only on the interactive elements within slots */
    ${TopLeftSlot}, ${TopRightSlot}, ${BottomLeftSlot} {
        pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
    }
`;
const MetricsToggle = styled.button `
    background: rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    color: white;
    cursor: pointer;
    font-size: 14px;
    margin-right: 8px;
    padding: 6px 8px;
    transition: background-color 0.2s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.9);
    }

    &:active {
        transform: scale(0.95);
    }
`;
const LayoutButton = styled(Button) `
    --Button_Width: 3rem;
    --Button_Height: 3rem;
    color: var(--tv-ui-color-3);
`;
